"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationBreadcrumbs = exports.useNavigation = exports.getNavigationPath = exports.navigateBack = exports.navigateTo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const LocalJSON_1 = require("./Storage/LocalJSON");
const TRAIL_PREFIX = "Trail";
const MAIN_TRAIL = "Default";
const TRAIL_SERVICE = (0, LocalJSON_1.getLocalJSON)(TRAIL_PREFIX);
const DEFAULT_TRAIL = (TRAIL_SERVICE.read(MAIN_TRAIL) ||
    []);
const navigateTo = (breadcrumb, trail = []) => [...trail, breadcrumb];
exports.navigateTo = navigateTo;
const navigateBack = (trail = []) => {
    const [_lastBreadCrumb, ...newTrail] = [...trail].reverse();
    return newTrail.reverse();
};
exports.navigateBack = navigateBack;
const getNavigationPath = (trail = []) => {
    return (trail
        .map(({ path }) => path)
        // @ts-ignore
        .flat());
};
exports.getNavigationPath = getNavigationPath;
const useNavigation = (storeTrail = false) => {
    const [trail, setTrail] = (0, react_1.useState)(storeTrail ? DEFAULT_TRAIL : []);
    const path = (0, react_1.useMemo)(() => (0, exports.getNavigationPath)(trail), [trail]);
    const onNavigateTo = (0, react_1.useCallback)((breadcrumb) => setTrail((0, exports.navigateTo)(breadcrumb, trail)), [trail, setTrail]);
    const onNavigateBack = (0, react_1.useCallback)(() => setTrail((0, exports.navigateBack)(trail)), [trail, setTrail]);
    const navigation = (0, react_1.useMemo)(() => ({
        trail,
        path,
        onNavigateTo,
        onNavigateBack,
        onSetTrail: setTrail,
    }), [trail, path, onNavigateTo, onNavigateBack]);
    (0, react_1.useEffect)(() => {
        if (storeTrail) {
            TRAIL_SERVICE.update(MAIN_TRAIL, trail);
        }
    }, [trail, storeTrail]);
    return navigation;
};
exports.useNavigation = useNavigation;
const BreadcrumbBox = styled_components_1.default.div `
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1em;
  overflow: auto;
  width: 100%;
`;
const BreadcrumbButton = styled_components_1.default.button `
  flex: 1 0 auto;
  text-wrap: none;
  width: auto;
`;
const NavigationBreadcrumbs = ({ trail, onChange, }) => {
    const listRef = (0, react_1.useRef)(null);
    const onGoToBreadcrumb = (0, react_1.useCallback)((event) => {
        const { target: { value }, } = event;
        const index = parseInt(value, 10);
        const newTrail = [...trail].slice(0, index + 1);
        onChange(newTrail);
    }, [trail, onChange]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        (_b = (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.lastElementChild) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
    }, [trail]);
    return ((0, jsx_runtime_1.jsxs)(BreadcrumbBox, { ref: listRef, children: [trail.length > 0 ? ((0, jsx_runtime_1.jsx)(BreadcrumbButton, { type: "button", value: -1, onClick: onGoToBreadcrumb, children: "Home" })) : undefined, trail.map((bc, index) => {
                const { label } = bc;
                return ((0, jsx_runtime_1.jsx)(BreadcrumbButton, { disabled: index === trail.length - 1, type: "button", value: index, onClick: onGoToBreadcrumb, children: label }, index));
            })] }));
};
exports.NavigationBreadcrumbs = NavigationBreadcrumbs;
